import { Fragment } from "react";
import { useHeaderState } from "@components/Header/helpers";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { getGroupTitle } from "@routes/BreakingNews/utils/helpers";
import { BreakingNewsStoriesProps } from "@routes/BreakingNews/utils/types";
import { cn } from "@util/helpers";

import BreakingNewsCard from "./BreakingNewsCard";
import BreakingNewsDynamicAds from "./BreakingNewsDynamicAds";
import WhatsappQRBreakingNews from "./WhatsappQRBreakingNews";

const BreakingNewsStories = ({
  testId,
  rootClassName,
  articles,
  group,
  articlesBefore = 0,
}: BreakingNewsStoriesProps): React.ReactElement => {
  const { isSubscriber } = useUserInfo();
  const { showLowerNavBar } = useHeaderState();

  const groupTitle = getGroupTitle(group);

  return (
    <>
      {articles.length > 0 ? (
        <section className={rootClassName} data-testid={testId}>
          <h4
            className={cn(
              "sticky z-10 bg-white py-3 font-poppins text-lg font-medium tracking-[1px] duration-300 lg:static",
              showLowerNavBar ? "top-[50px]" : "top-[50px]"
            )}
          >
            {groupTitle.toUpperCase()}
          </h4>

          <div
            className={cn(
              "stories mt-3 space-y-4",
              "relative pl-20 before:absolute before:left-10 before:top-0 before:h-full before:w-[1px] before:bg-gray-175",
              "lg:pl-0 lg:before:hidden"
            )}
          >
            {articles.map((props, index) => {
              const totalArticlesIndex = index + articlesBefore;

              return (
                <Fragment key={props.id}>
                  {group === "today" && index === 2 ? (
                    <WhatsappQRBreakingNews />
                  ) : null}

                  {totalArticlesIndex > 0 ? (
                    <BreakingNewsDynamicAds
                      articleCounter={index + articlesBefore}
                      className="flex w-[calc(100%+5rem)] -translate-x-20 flex-col items-center justify-center overflow-hidden bg-white lg:w-auto lg:translate-x-0"
                    />
                  ) : null}

                  <BreakingNewsCard
                    basicCardProps={{
                      ...props,
                      paywall: isSubscriber ? props.paywall : false,
                    }}
                    isLast={index === articles.length - 1}
                  />
                </Fragment>
              );
            })}
          </div>
        </section>
      ) : null}
    </>
  );
};

export default BreakingNewsStories;
